export const toggleOpenTrackRow = (openTracks) => ({
  type: "TOGGLE_TRACK",
  payload: { openTracks }
});

export default toggleOpenTrackRow;
